module.exports = __webpack_public_path__ + "static/twitter-0deebf8573a205c14fa678247a5edc1d.png";